/**
 * triggerDescriptions.ts — plain-English phrasing for a workflow's trigger,
 * shared by the toolbar's "Simulate" button label and the activation
 * confirm dialog's "will run automatically whenever …" sentence.
 */

export function describeTriggerClause(type: string): string {
  switch (type) {
    case "manual":
      return "you click Run";
    case "meeting_filenote_completed":
      return "a meeting is completed (it waits for the file note to be generated first)";
    case "document_signed":
      return "a client finishes signing a document";
    case "fds_deadline_approaching":
      return "a client's Fee Disclosure Statement deadline is 14 days away";
    case "fact_find_completed":
      return "a client's fact find has no missing fields left";
    case "document_uploaded":
      return "a new file is uploaded to a client's Files";
    case "client_created":
      return "a new client is created";
    default:
      return `the "${type}" event occurs`;
  }
}

export function describeTriggerShort(type: string): string {
  switch (type) {
    case "manual":
      return "Manual";
    case "meeting_filenote_completed":
      return "Meeting completed";
    case "document_signed":
      return "Document signed";
    case "fds_deadline_approaching":
      return "FDS deadline approaching";
    case "fact_find_completed":
      return "Fact find completed";
    case "document_uploaded":
      return "Document uploaded";
    case "client_created":
      return "Client created";
    default:
      return type;
  }
}
